module.exports = __webpack_public_path__ + "img/42-Black Ulti-Matt.jpg";